<mat-grid-list cols="11" rowHeight="50px" class="document_ar" >
  <mat-grid-tile colspan="1" rowspan="2">
    <i class="material-icons" *ngIf="!editMode">feed</i>
    <button *ngIf="editMode"
            mat-raised-button
            color="primary"
            [matTooltip]="'Editer le document'"
            (click)="editDocument()"
            data-cy="btn-preview-doc-edit">
      <mat-icon>feed</mat-icon>
    </button>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="1" class="title">
    <div fxFlex fxLayoutAlign="start">Nature</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1" class="title">
    <div fxFlex fxLayoutAlign="start">Durée</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1" class="title">
    <div fxFlex fxLayoutAlign="start">Sort final</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1" class="title">
    <div fxFlex fxLayoutAlign="start">Année de création</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="5" rowspan="1" class="title">
    <div fxFlex fxLayoutAlign="start">Description</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="2" rowspan="3">
    <div fxFlex fxLayoutAlign="start" [matTooltip]="displayNature()" [matTooltipClass]="'tooltip'">{{displayNature()}}</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1">
    <div fxFlex fxLayoutAlign="start">{{displayDuration()}}</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1">
    <div fxFlex fxLayoutAlign="start" [matTooltip]="depositSvc.displayConservationDefault(document?.dua_obj?.final_fate)">
      {{depositSvc.displayConservationDefault(document?.dua_obj?.final_fate)}}
    </div>
  </mat-grid-tile>
  <mat-grid-tile colspan="1" rowspan="1">
    <div fxFlex fxLayoutAlign="start">{{document?.creation_year}}</div>
  </mat-grid-tile>
  <mat-grid-tile colspan="5" rowspan="2">
    <div fxFlex fxLayoutAlign="start" [matTooltip]="document?.description">
      <p [innerHTML]="document?.description | newline"></p>
    </div>
  </mat-grid-tile>
</mat-grid-list>

